import script from "./ViewModeTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewModeTooltip.vue?vue&type=script&setup=true&lang=js"

import "./ViewModeTooltip.vue?vue&type=style&index=0&id=9fa8b998&lang=css"

const __exports__ = script;

export default __exports__